import {
  PdfSearchUtil
} from "./chunk-BJC25M5U.js";
import {
  Debounce,
  GlobalEvents,
  SnippetElement,
  defineElement,
  globalOn,
  onClick,
  param,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/common-search-modal/common-search-modal.ts
var _a, _b, _c;
var CommonSearchModal = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.baseUrl = `${(_c = (_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) != null ? _c : ""}`;
  }
  closeSearchModal() {
    var _a2;
    (_a2 = this.searchModal) == null ? void 0 : _a2.close();
  }
  get loading() {
    var _a2, _b2;
    return (_b2 = (_a2 = this.resultBar) == null ? void 0 : _a2.hasAttribute("loading")) != null ? _b2 : false;
  }
  set loading(val) {
    var _a2, _b2, _c2, _d, _e, _f;
    if (val) {
      (_a2 = this.resultBar) == null ? void 0 : _a2.setAttribute("loading", "");
      (_b2 = this.loadingIcon) == null ? void 0 : _b2.classList.remove("hidden");
      (_c2 = this.closeIcon) == null ? void 0 : _c2.classList.add("hidden");
    } else {
      (_d = this.resultBar) == null ? void 0 : _d.removeAttribute("loading");
      (_e = this.loadingIcon) == null ? void 0 : _e.classList.add("hidden");
      (_f = this.closeIcon) == null ? void 0 : _f.classList.remove("hidden");
    }
  }
  connectedCallback() {
    var _a2, _b2;
    const debouncedRender = Debounce.debounce(() => {
      this.fetchSearchResults();
    }, (_a2 = this.time) != null ? _a2 : 800);
    (_b2 = this.searchInput) == null ? void 0 : _b2.addEventListener("input", () => {
      var _a3, _b3, _c2, _d, _e;
      const inputValue = (_c2 = (_b3 = (_a3 = this.searchInput) == null ? void 0 : _a3.value) == null ? void 0 : _b3.trim()) != null ? _c2 : "";
      if (inputValue === "") {
        this.clearResults();
        return;
      }
      this.loading = true;
      (_d = this.resultBar) == null ? void 0 : _d.classList.remove("hidden");
      (_e = this.resultBar) == null ? void 0 : _e.classList.add("flex");
      debouncedRender();
    });
  }
  clearResults() {
    var _a2, _b2;
    this.output.innerHTML = "";
    (_a2 = this.resultBar) == null ? void 0 : _a2.classList.add("hidden");
    (_b2 = this.resultBar) == null ? void 0 : _b2.classList.remove("flex");
    this.loading = false;
  }
  resetInput() {
    var _a2;
    (_a2 = this.searchInput) == null ? void 0 : _a2.setAttribute("value", "");
    this.searchInput.value = "";
    this.clearResults();
  }
  fetchSearchResults() {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d;
      const inputValue = (_c2 = (_b2 = (_a2 = this.searchInput) == null ? void 0 : _a2.value) == null ? void 0 : _b2.trim()) != null ? _c2 : "";
      if (inputValue === "") {
        this.clearResults();
        return;
      }
      try {
        const [shopifyResults, pdfResults] = yield Promise.all([
          this.fetchShopifyResults(inputValue),
          this.fetchPdfResults(inputValue)
        ]);
        this.combineAndDisplayResults(shopifyResults, pdfResults);
      } catch (error) {
        console.error("Search failed:", error);
      }
      this.loading = false;
      (_d = this.resultBar) == null ? void 0 : _d.classList.add("hidden");
      GlobalEvents.emit("recommendation:performed");
    });
  }
  fetchShopifyResults(inputValue) {
    return __async(this, null, function* () {
      const response = yield fetch(`${this.baseUrl}search?q=${encodeURIComponent(inputValue)}&section_id=common-main-search`);
      if (response.status === 422) {
        return null;
      }
      const text = yield response.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      return html.querySelector("[data-search-results]");
    });
  }
  fetchPdfResults(inputValue) {
    return __async(this, null, function* () {
      try {
        const results = yield PdfSearchUtil.searchPdf(inputValue);
        return results.slice(0, 9);
      } catch (error) {
        console.error("PDF search failed:", error);
        return [];
      }
    });
  }
  combineAndDisplayResults(shopifyResults, pdfResults) {
    if (!this.output)
      return;
    let combinedHTML = "";
    if (shopifyResults) {
      combinedHTML += shopifyResults.innerHTML;
    }
    if (pdfResults.length > 0) {
      const pdfCards = pdfResults.map((result) => PdfSearchUtil.createPdfCard(result)).join("");
      combinedHTML += pdfCards;
    }
    this.output.innerHTML = combinedHTML;
  }
  showResults() {
    var _a2, _b2;
    (_a2 = this.resultBar) == null ? void 0 : _a2.classList.remove("hidden");
    (_b2 = this.resultBar) == null ? void 0 : _b2.classList.add("flex");
  }
};
__decorateClass([
  query("[data-output]")
], CommonSearchModal.prototype, "output", 2);
__decorateClass([
  query("[data-search-input]")
], CommonSearchModal.prototype, "searchInput", 2);
__decorateClass([
  query("[data-result-bar]")
], CommonSearchModal.prototype, "resultBar", 2);
__decorateClass([
  query("[data-close-icon]")
], CommonSearchModal.prototype, "closeIcon", 2);
__decorateClass([
  query("[data-loading-icon]")
], CommonSearchModal.prototype, "loadingIcon", 2);
__decorateClass([
  param()
], CommonSearchModal.prototype, "time", 2);
__decorateClass([
  query("[search-modal]")
], CommonSearchModal.prototype, "searchModal", 2);
__decorateClass([
  globalOn("cart:open")
], CommonSearchModal.prototype, "closeSearchModal", 1);
__decorateClass([
  onClick("[data-input-reset]")
], CommonSearchModal.prototype, "resetInput", 1);
__decorateClass([
  globalOn("recommendation:performed")
], CommonSearchModal.prototype, "showResults", 1);
CommonSearchModal = __decorateClass([
  defineElement()
], CommonSearchModal);
export {
  CommonSearchModal
};
